import { useQuery } from "@tanstack/react-query";
import { terminalInventoryKeys } from "Api/Queries/TerminalInventory/useTerminalInventoryListQuery";
import { getTerminalInventoryPublicIDAudit } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

// Shares the terminal inventory root key, so update/shipped mutations invalidate it too.
export const terminalInventoryAuditKeys = {
  byPublicId: (publicID: string) => [
    ...terminalInventoryKeys.all,
    "audit",
    publicID,
  ],
};

export const useTerminalInventoryAuditQuery = (publicID: string) =>
  useQuery({
    queryKey: terminalInventoryAuditKeys.byPublicId(publicID),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTerminalInventoryPublicIDAudit(publicID),
    ),
  });
